export default __webpack_public_path__ + "static/media/2.91fca7f7.png";